import moment from 'moment'
import { getDataLunar } from '../calender'

const FORMAT_DATE = 'YYYY-MM-DD'
const DAYNAMES = ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy']

const getListDate = (dates) => {
  if (dates.length === 1) {
    return [moment(dates, FORMAT_DATE)]
  }
  let startDate = moment(dates[0], FORMAT_DATE)
  const endDate = moment(dates[1], FORMAT_DATE)
  const listDate = []
  listDate.push(moment(startDate))
  while (startDate.format(FORMAT_DATE) !== endDate.format(FORMAT_DATE)) {
    startDate = startDate.add(1, 'days')
    listDate.push(moment(startDate))
  }
  return listDate
}

export const getLich = (dates) => {
  if (!dates || !dates.length) {
    return []
  }
  const listDate = getListDate(dates)
  const dataLunars = []
  listDate.forEach((mDate) => {
    const month = mDate.month() + 1
    const year = mDate.year()
    const day = mDate.date()
    const dayName = DAYNAMES[mDate.format('d')]
    const dataLunar = getDataLunar(month, year, day)
    dataLunar.dl = { day, month, year, dayName }
    dataLunars.push(dataLunar)
  })
  return dataLunars
}
